module.exports = __webpack_public_path__ + "images/tvi.png?40cb670c361e1b8853e56d4dca43209e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tvi.png
// module id = 56
// module chunks = 0